import $ from "jquery";

$(document).on("click", "a.wp-block-navigation-item__content", function() {
    $('.wp-block-navigation__responsive-container-close').trigger("click");
});
